<template>
    <div>
        <el-select
            v-model="quote_id"
            filterable
            clearable
            remote
            placeholder="Search by a Quote/Employer/Author"
            :remote-method="querySearch"
            :loading="loading"
            style="width: 100%"
            @change="$emit('selected', quote_id)"
        >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    data() {
        return {
            quote_id: null,
            loading: false,
            options: []
        };
    },
    methods: {
        querySearch: _.debounce(function(query) {
            this.loading = true;

            axios.get(url(`admin/quotes/search?q=${query}`))
                .then(response => {
                    this.options = response.data;
                    this.loading = false;
                });
        }, 250)
    },
};
</script>
